import React from "react";

// One row in a MasterDetailListShell's compact list - generic presentational
// shell (avatar + title/subtitle + badge + action icons) so each module's
// compact list only supplies its own data/icons, not the row markup itself.
const MasterDetailRow = ({ isSelected, onClick, avatarLabel, title, subtitle, badge, actions }) => (
  <li
    className={`master-detail-row${isSelected ? " is-selected" : ""}`}
    onClick={onClick}
  >
    {avatarLabel && <span className="master-detail-avatar">{avatarLabel}</span>}
    <div className="master-detail-row-main">
      <div className="master-detail-row-title">{title}</div>
      {subtitle && <div className="master-detail-row-sub">{subtitle}</div>}
    </div>
    {badge}
    {actions && <div className="d-flex align-items-center">{actions}</div>}
  </li>
);

export default MasterDetailRow;
